import { memo, Reducer, useCallback, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from "react-i18next"
import { colors, css, fonts, frames, glyphs, useMediaQuery } from '../../../../Styles';
import { BluePrint } from '../../../../Assets/Glyphs/bluePrint';
import { PageHeader, PenModal, ToggleBox, NewModal, MainContentPaddingTypes, BluePrintModal, LF_PENLIST, Overlay, SectionModal, NewButtonList, NewSelect, NewInput, AreaLayout, NewSectionModal, LoadingSpinner, EditLfSectionModal, SuccessAnimation } from "../../../../Components"
import { contents } from '../../../../Components/Layouts/_Layouts/btnContents';
import { getButtonStyles } from '../../../../Components/Layouts/_Layouts/btnStyles';
import { currentLfViewTypes, ILfContext, LfContext, LfDispatcherT, LfReducer } from '../../../../Components/LocationFeeder/_LocationFeeder/lfPenContext';
import { ButtonTypes, NewFieldStyles, NewFieldTypes, SystemTypes } from '../../../../Definitions';
import { Graph_QL, useOldSection, useSystem, Location, SectionsInfo } from '../../../../Services';
import { selectByLocations } from '../../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/AnimalDataSlices/animalsSlice';
import { selectAllLocations, selectLocationsBySection, selectLocationsBySystem } from '../../../../Services/Agrisys_GqlDataCaller/SectionsCalls/locationSlice';
import { RootState, useAppDispatch, useAppSelector } from '../../../../Store';
import { SET_ACTIVE_PEN } from '../../../../Store/UI/modalRedirectSlice';
import { useDispatch, useSelector } from 'react-redux';
import { isEqual } from 'lodash';
import { Pages } from '../../../../Navigation/root';
import { SectionReorder } from '../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/createLfSectionCall';
import { useSystemInfoById } from '../../../../Services/Agrisys_GqlDataCaller/SystemCalls/systemSlice';
import { useSection } from '../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useSections';
import { dispatchFetchSectionBySystem, selectSectionsBySystem } from '../../../../Services/Agrisys_GqlDataCaller/SectionsCalls/sectionsSlice';
import { selectLocationOptionsBySection } from '../../../../Store/OptionsHandlers/optionsCombinedReducer';


const penContentOptions = [
  { id: 0, label: "animal number" },
  { id: 1, label: "pen name" }
]

export function sortSections({ section_order: sectionOrderA, section_id: sectionIdA }: SectionReorder, { section_order: sectionOrderB, section_id: sectionIdB }: SectionReorder, sectionOrderRecord?: Record<number, SectionReorder>) {
  let orderA = sectionOrderA;
  let orderB = sectionOrderB;

  if (sectionOrderRecord && sectionOrderRecord[sectionIdA] && sectionOrderRecord[sectionIdA].section_order !== 0) {
    orderA = sectionOrderRecord[sectionIdA].section_order;
  }

  if (sectionOrderRecord && sectionOrderRecord[sectionIdB] && sectionOrderRecord[sectionIdB].section_order !== 0) {
    orderB = sectionOrderRecord[sectionIdB].section_order;
  }

  if (orderA < 0 && orderB > 0) {
    return 1;
  }
  if (orderA > 0 && orderB < 0) {
    return -1;
  }
  if (orderA - orderB === 0) {
    return sectionIdA - sectionIdB;
  }
  return orderA - orderB

}

export default function FreedaLocationFeeder() {
  const { t } = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 450px)`);
  const [currentViewType, setCurrentViewType] = useState<"TODAY" | "YESTERDAY" | "ATTENTIONS" | "BASIC">("TODAY");
  const [activeSection, setActiveSection] = useState<SectionsInfo | undefined>();
  const [activePen, setActivePen] = useState<Location | undefined>();
  const [editSections, setEditSections] = useState(false)
  const [newSectionModal, setNewSectionModal] = useState(false)
  const [bluePrintModal, setBluePrintModal] = useState<boolean>(false)
  const successMode = useSelector((state: RootState) => state.uiState.successMode.successMode);
  const successMessage = useSelector((state: RootState) => state.uiState.successMode.successMessage);
  const sectionOrderRef = useRef<Record<number, SectionReorder>>({})
  const [sectionOrderRecord, setSectionOrderRecord] = useState<Record<number, SectionReorder>>({})

  const appDispatch = useAppDispatch();

  // #region | GraphQL
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const { domain, connection } = useMemo(() => {
    let domain = Graph_QL.ObjToString({ domain: farm });
    let connection = Graph_QL.create({ domain: farm });
    return { domain, connection };
  }, [farm]);

  const { reorderSectionLocations } = useSection()
  const { systemId: urlSystemId } = useParams();
  const systemId = Number(urlSystemId)

  // System
  const { isLoading: loading, entity: system } = useSystemInfoById(systemId);

  appDispatch(dispatchFetchSectionBySystem(systemId));
  // Sections
  const sections = useAppSelector((state) => selectSectionsBySystem(state, systemId), isEqual);
  const sortedSections = [...sections].sort((a, b) => a.section_id - b.section_id);

  const currentSectionIndex = sortedSections.findIndex(s => s.section_id === activeSection?.section_id)

  const currentSectionPens = useAppSelector((state) => { if (activeSection?.section_id) { return selectLocationsBySection(state, [activeSection.section_id]) } return [] }, isEqual)
  const currentSystemPens = useAppSelector((state) => { return selectLocationsBySystem(state, [systemId]) }, isEqual)
  const systemPensBySection = Object.groupBy(currentSystemPens, (pen) => pen.sectionId)
  // Drop this state and the state for section ??
  // Current Pen
  const sortedPens = [...currentSectionPens].sort((a, b) => a.location_id - b.location_id);
  
  const currentPenIndex = sortedPens.findIndex(s => s.location_id === activePen?.location_id);

  // Animals
  const animalsInSection = useAppSelector((state) => { if (sortedPens.length) { return selectByLocations(state, sortedPens.map((pen) => pen.location_id)) } }, isEqual)
  // #endregion

  // #region | Reducer
  const [_state, dispatch] = useReducer<Reducer<ILfContext, LfDispatcherT>>(LfReducer, {
    farm: farm,
    domain: domain,
    connection: connection,
    systemId: systemId,
    sections: sections,
    selectedPens: [],
    penContent: 0,
    currentPenViewType: currentLfViewTypes.remainingToday,
    error: { Elementid: 0, errorText: "" }
  } as ILfContext);

  useEffect(() => {
    dispatch({ sections: sections });
  }, [sections]);
  // #endregion

  // #region | Visited Pen
  const dispatchRoute = useDispatch();
  const thisActivePen = useSelector((state: RootState) => state.uiState.modalRedirect.activePen);
  const hasLastVisitedPen = thisActivePen?.type === "lf" && thisActivePen.system === system?.system_id;
  const lastVisitedPen = thisActivePen?.type === "lf" ? thisActivePen.location : undefined;
  const lastVisitedSection = thisActivePen?.type === "lf" ? thisActivePen.group : undefined;
  //#endregion

  // Visited Pen

  // Handle Pen Click
  const handlePenClick = useCallback((location_id: Number) => {
    let pen = sortedPens.find((pen) => pen.location_id === location_id)
    if (!pen) return;
    return setActivePen(pen)
  }, [sortedPens])

  // #region | Section Click
  const handleSectionClick = (section_id: number) => {
    const section = sections.find(s => s.section_id === section_id);
    if (!section) return;

    setActiveSection(section);
  };

  const section = useMemo(() => {
    if (!activeSection || !system) return null;
    return (
      <SectionModal
        sectionId={activeSection.section_id}
        system={system}
        pens={sortedPens}
        onPenClick={(location_id: number) => handlePenClick(location_id)}
        animalsInSection={animalsInSection ?? []}
        connect={{
          connection: connection,
          domain: domain,
          farm: farm
        }}
      />
    )
  }, [activeSection, animalsInSection, connection, sortedPens, domain, farm, handlePenClick, system]);
  // #endregion

  // #region | Toggles
  const toggleRouter = (viewType: "TODAY" | "YESTERDAY" | "ATTENTIONS") => {
    if (currentViewType === viewType) {
      setCurrentViewType("BASIC");
      dispatch({ currentPenViewType: currentLfViewTypes.basic });
      return;
    }
    setCurrentViewType(viewType);

    const dispatchMap = {
      TODAY: currentLfViewTypes.remainingToday,
      YESTERDAY: currentLfViewTypes.remainingYesterday,
      ATTENTIONS: currentLfViewTypes.attention,
    };

    dispatch({ currentPenViewType: dispatchMap[viewType] });
  };
  // #endregion

  // #region | Button List
  const ButtonRow = memo(({ editTable }: { editTable: boolean }) => {
    const [contentsRes, icons, onClicks] = contents(
      () => { setNewSectionModal(true) },
      () => { setEditSections(true); setCurrentViewType("BASIC"); dispatch({ currentPenViewType: currentLfViewTypes.basic }) },
      () => { setEditSections(false); setCurrentViewType("TODAY"); dispatch({ currentPenViewType: currentLfViewTypes.remainingToday }); sectionOrderRef.current = {}; setSectionOrderRecord({}) },
      () => {
        const changes = Array.from(Object.values(sectionOrderRef.current)).filter(({ section_order }) => section_order !== 0);
        if (!changes.length) {
          setEditSections(false);
          setSectionOrderRecord({});
          return;
        }
        reorderSectionLocations(changes);
        setEditSections(false);
        setSectionOrderRecord({});
      },
      t("buttons.add", { defaultValue: "Add" }),
      t("buttons.edit", { defaultValue: "Edit" }),
      t("buttons.cancel", { defaultValue: "Cancel" }),
      t("button.save", { defaultValue: "Save" }),
      editTable
    )

    return (
      <NewButtonList
        contents={contentsRes}
        onClick={(i) => { onClicks[i]?.() }}
        buttonType={ButtonTypes.tableButton}
        startEnhancers={icons}
        disabled={editTable ? [false, false, true, true] : [false, false]}
        overrides={(index) => {
          const { backgroundColor, opacity } = getButtonStyles(index, editTable);
          return {
            baseButton: { backgroundColor: backgroundColor },
            disabledStyles: { opacity: opacity, backgroundColor: backgroundColor }
          }
        }}
      />
    )
  })
  // #endregion

  if (!systemId) return null;

  return (
    <frames.Page_inner>
      <PageHeader topHeader={system?.name} subHeader={t(`menuHeaders.${Pages.freeda_lf_sections}`, { defaultValue: "sections" })} />
      <frames._page_inner_content style={{ zIndex: editSections ? "9999" : "0" }}>
        <AreaLayout
          zIndex={editSections ? 999 : 0}
          editableTable={editSections}
          headerArea={
            <p style={{ ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, marginBottom: "5px" }}>
              {sections.length} {sections.length === 1 ? t("locationFeederPages.sections.section", { defaultValue: "section" }) : t("locationFeederPages.sections.sections", { defaultValue: "sections" })}
            </p>
          }
          buttonArea={<ButtonRow editTable={editSections} />}
          topArea={<>
            <frames.ToggleBox style={{ columnGap: mobileXs ? "10px" : "30px" }}>
              <ToggleBox disabled={editSections ? true : false} text={t("feed.general.remainingToday", { defaultValue: "remaining today" })} icon={glyphs.TimeToday({ size: "17px" })} onChange={() => toggleRouter("TODAY")} isChecked={currentViewType === "TODAY" ? true : false} />
              <ToggleBox disabled={editSections ? true : false} text={t("feed.general.remainingYesterday", { defaultValue: "remaining yesterday" })} icon={glyphs.TimeYesterday({ size: "17px" })} onChange={() => toggleRouter("YESTERDAY")} isChecked={currentViewType === "YESTERDAY" ? true : false} />
              <ToggleBox disabled={editSections ? true : false} text={t("systemControls.general.attentions", { defaultValue: "attentions" })} icon={<div style={{ marginTop: "1px" }}><glyphs.Attention size="17px" /></div>} onChange={() => toggleRouter("ATTENTIONS")} isChecked={currentViewType === "ATTENTIONS" ? true : false} />
            </frames.ToggleBox>
            <NewSelect
              options={penContentOptions}
              fieldOverrides={{
                fieldStyle: NewFieldStyles.greySecondary,
                fieldWidth: "150px"
              }}
              valueOverrides={{
                defaultValue: penContentOptions[0]
              }}
              onChange={(value) => { dispatch({ penContent: Number(value?.id) }) }}
            />
          </>}
          contentArea={<>
            {loading && <div style={{ width: "100%", display: "flex", justifyContent: "center" }}><LoadingSpinner /></div>}
            {(!loading && (sections.length === 0 || sections === undefined)) ? <p style={{ ...css.emptyPen, textAlign: "center" }}>{t("locationFeederPages.sections.noSections", { defaultValue: "No sections found" })}</p> : <></>}
            {!loading && (sections.length !== 0 || sections !== undefined) &&
              <LfContext.Provider value={{ state: _state, dispatch }}>
                <frames.PenListsWrapper style={{ justifyContent: mobileXs ? "center" : "start" }}>
                  {(editSections && activeSection !== undefined) ? undefined : _state.sections?.sort((sectionA, sectionB) => sortSections(sectionA, sectionB, sectionOrderRecord))?.map((section, index) => (
                    <div key={index} onClick={() => handleSectionClick(section.section_id)} style={{ height: "fit-content", width: "fit-content" }}>
                      <LF_PENLIST
                        key={section.section_id}
                        section={section}
                        pens={systemPensBySection[section.section_id]}
                      />
                    </div>
                  ))}
                </frames.PenListsWrapper>
              </LfContext.Provider>
            }
          </>}
          additionalArea={<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "200px 60px", gridTemplateRows: "auto", gap: "20px" }}>
              <p style={{ ...fonts.fontSize4, ...fonts.paragraph, ...fonts.fontWeight2, color: colors.whitePrimary, borderBottom: "2px solid " + colors.greySecondary + 80 }}>{t("locationFeederPages.sections.section", { defaultValue: "Section" })}</p>
              <p style={{ ...fonts.fontSize4, ...fonts.paragraph, ...fonts.fontWeight2, color: colors.whitePrimary, borderBottom: "2px solid " + colors.greySecondary + 80 }}>{t("locationFeederPages.sections.priority", { defaultValue: "Priority" })}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {sections.sort(sortSections).map((section) => (
                <div style={{ display: "grid", gridTemplateColumns: "200px 60px", gridTemplateRows: "auto", gap: "20px" }}>
                  <p style={{ ...fonts.fontSize4, ...fonts.paragraph, color: colors.greyLightTertiary, display: "flex", alignItems: "center" }}>{section.name}</p>
                  <NewInput
                    onChange={(value) => {
                      if (Number(value) === section.section_order || (value === "" && section.section_order === -1)) {
                        sectionOrderRef.current[section.section_id] = { section_id: section.section_id, section_order: 0 }
                        return;
                      }
                      sectionOrderRef.current[section.section_id] = { section_id: section.section_id, section_order: value === "" ? -1 : Number(value) }
                    }}
                    onBlur={() => setSectionOrderRecord({ ...sectionOrderRef.current })}
                    fieldOverrides={{
                      fieldType: NewFieldTypes.tertiaryField,
                      fieldStyle: NewFieldStyles.greySecondary,
                      fieldWidth: "60px"
                    }}
                    valueOverrides={{
                      valueType: "number",
                      defaultValue: section.section_order > 0 ? section.section_order : undefined,
                      minValueNumber: 1,
                      maxValueNumber: 99,
                      allowDelete: true,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>}
          lastVisitedLocation={{
            onClick: () => { setActivePen(lastVisitedPen); setActiveSection(lastVisitedSection) },
            disabled: !hasLastVisitedPen
          }}
          bluePrint={{
            disabled: editSections ? true : false,
            onClick: () => setBluePrintModal(true),
            startEnhancer: BluePrint({})
          }}
        />
      </frames._page_inner_content>

      {/* Section and pen Modals */}
      {!editSections && system && (activePen || activeSection) ?
        <NewModal
          header={activePen !== undefined ? `${t("locationFeederPages.locationFeeder.pen", { defaultValue: "Pen" })} ${activePen.name}` : activeSection?.name ?? ""}
          subHeader={activePen !== undefined ? `${system?.name} ${activeSection?.name ?? ""}` : `${system?.name}`}
          overrides={{
            backgroundColor: colors.greyLightTertiary,
            mainContentPadding: MainContentPaddingTypes.primary,
            mainContentScroll: true
          }}
          predefinedButtons={{
            onClose: () => {
              setActiveSection(undefined)
              if (activePen !== undefined && activeSection !== undefined) { dispatchRoute(SET_ACTIVE_PEN({ type: "lf", location: activePen, group: activeSection, system: system.system_id })); setActivePen(undefined) }
            },
            onGoBack: activePen !== undefined ? () => setActivePen(undefined) : undefined,
            onPrev: () => activePen !== undefined
              ? setActivePen(sortedPens[(currentPenIndex - 1 + sortedPens?.length) % sortedPens.length])
              : setActiveSection(sortedSections[(currentSectionIndex - 1 + sortedSections.length) % sortedSections.length]),
            onNext: () => activePen !== undefined
              ? setActivePen(sortedPens[(currentPenIndex + 1) % sortedPens.length])
              : setActiveSection(sortedSections[(currentSectionIndex + 1) % sortedSections.length]),
          }}
          mainContent={
            <div style={{ width: "735px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              {activePen === undefined && activeSection ?
                <>{section}</>
                : activePen !== null ?
                  <PenModal activePen={activePen} system={system} section={activeSection} /> // PEN POPUP
                  : null
              }
            </div>
          }
        />
        : <></>}

      {/* Blue Print Modal */}
      {system && bluePrintModal && (
        <BluePrintModal system={system} onClose={() => setBluePrintModal(false)} />
      )}

      {newSectionModal && (
        <NewSectionModal
          closeModal={() => { setNewSectionModal(false); }}
          systemId={systemId}
          systemType={SystemTypes.freedaLf}
        />
      )}
      {editSections && (activeSection === undefined ? <Overlay /> :
        <LfContext.Provider value={{ state: _state, dispatch }}>
          <EditLfSectionModal
            closeModal={() => { setActiveSection(undefined); setEditSections(false); dispatch({ currentPenViewType: currentLfViewTypes.remainingToday, selectedPens: [] }); toggleRouter("TODAY") }}
            section={activeSection}
          />
        </LfContext.Provider>
      )}
      {successMode && <SuccessAnimation />}
    </frames.Page_inner>
  )
}
